import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {omit} from 'lodash'
import {addNotification} from 'reapop'

const WithNotify = WrappedComponent => {
  return class extends Component {
    constructor() {
      super()
      this.notify = this.notify.bind(this)
    }

    notify(message) {
      let status = 'success';
      let position = {value : 'tl'}
      
      this.props.addNotification({
        title: 'Great',
        message: message,
        status: status,
        position: position.value,
        dismissible: true,
        dismissAfter: 3000
      })
    }

    render() {
      let props = omit(this.props, ['addNotification']);

      return (
        <WrappedComponent
          notify={this.notify}
          {...props}
        />
      )
    }
  }
}

export default compose(connect(null, {addNotification}), WithNotify)